import { FC } from 'react'
import { useAtomValue } from 'jotai'
import { workspaceRecentTipsAtom } from '@/store/workspaceAtoms'
import { useTar } from '@/modules/i18n'
import { Lightbulb } from 'lucide-react'
import { MarkdownEditor } from '@duck/ui'
import { RelativeDateTime } from '@/components/datetime/RelativeDateTime'

export const TipsHistoryTab: FC = () => {
    const tips = useAtomValue(workspaceRecentTipsAtom)
    const { t } = useTar()

    if (tips.length === 0) {
        return (
            <div className="flex flex-col items-center justify-center h-full text-muted-foreground gap-2">
                <Lightbulb className="size-8 opacity-30" />
                <p className="text-sm">{t('challenges.noTipsYet')}</p>
            </div>
        )
    }

    return (
        <div className="p-4 lg:p-6 space-y-3 max-w-2xl">
            {tips.map((entry, i) => (
                <div
                    key={`${entry.challengeId}-${i}`}
                    className="rounded-lg border border-border bg-muted/30 p-4 space-y-2.5"
                >
                    <div className="flex items-center justify-between gap-2">
                        <span className="text-sm font-medium truncate">
                            {entry.taskName}
                        </span>
                        <RelativeDateTime
                            isoDateString={entry.date}
                            className="text-xs text-muted-foreground shrink-0"
                        />
                    </div>
                    <ul className="space-y-1.5">
                        {entry.tips.map((tip, j) => (
                            <li key={j} className="flex gap-2 text-sm text-muted-foreground">
                                <Lightbulb className="size-3.5 shrink-0 mt-0.5 text-yellow-500/70" />
                                <MarkdownEditor
                                    defaultValue={tip}
                                    mode="view"
                                    noBorder
                                    mdClassName="p-0 text-sm text-muted-foreground prose-p:text-muted-foreground"
                                />
                            </li>
                        ))}
                    </ul>
                </div>
            ))}
        </div>
    )
}
